<template>
  <div id="wrapper">
    <Spinner :isLoading="isLoading" />
    <div class="login-logo">
      <h1>
        <img src="/common/img/logo.png" alt="nanacara for Doctor" height="40" />
      </h1>
      <div style="margin-top: 35px">
        <p class="mb30" style="font-size: 20px">確認コード入力</p>
        <p class="mb30" style="font-size: 20px">
          確認コード入力を送信しました。
        </p>
        <p>
          ご本人様確認のため登録されいている情報に確認コードを送信しました。<br />
          送られている認証コードを入力してください。
        </p>
      </div>
    </div>
    <div id="login-wrap">
      <div>
        <form @submit.prevent="onConfirmPhoneNumber()" method="post">
          <p class="mb20">確認コード</p>
          <input type="text" name="code" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            maxlength="6" id="" class="mb40" v-model="code" />
          <div v-if="submitted && $v.code.$error">
            <p class="error-txt mb20" v-if="!$v.code.required">
              {{ $t("please_enter_the_verification_code") }}
            </p>
          </div>
          <div class="mb10">
            <p class="error-txt mb10" v-if="errConfirmPhoneNumber && submitted">
              {{ errConfirmPhoneNumber }}
            </p>
          </div>
        </form>

        <div class="btn-base mb30" v-on:click="onConfirmPhoneNumber()">
          <a href="javascript:;">
            <p>ログイン</p>
          </a>
        </div>
        <div class="btn-cancel" style="background: #fff; border: 1px solid #ffa300" v-on:click="resendCode()">
          <a href="javascript:;">
            <p>確認コードを再送信する</p>
          </a>
        </div>
      </div>
    </div>

    <div id="modal">
      <b-modal id="modal-error" centered :hide-header="true" :hide-footer="true" class="modal-content">
        <div class="modal-inner">
          <p class="modal-ttl" style="font-weight: 600">
            {{ $t("verify_code.resend_code_title") }}
          </p>
          <p class="modal-txt-error mb50" v-html="$t('verify_code.resend_code_content')"></p>
          <div class="btn-base pos-center">
            <a href="javascript:;" class="modal-close" @click="handleModal">
              <p>{{ $t("ok") }}</p>
            </a>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import Spinner from "@/js/components/Spinner";
import Loading from "@/js/components/Loading";
window.Vue = require("vue");

export default {
  data() {
    return {
      isLoading: false,
      code: "",
      submitted: false,
    };
  },
  components: {
    Loading,
    Spinner,
  },
  validations: {
    code: { required },
  },
  computed: {
    ...mapState({
      access_token: (state) => state.auth.access_token,
      errConfirmPhoneNumber: (state) => state.auth.errConfirmPhoneNumber,
      phoneNumber: (state) => state.auth.phoneNumber,
    }),
  },
  methods: {
    async resendCode() {
      this.isLoading = true;
      this.submitted = true;
      let params = {
        phone_number: this.phoneNumber,
        access_token: this.access_token,
      };
      await this.$store.dispatch("auth/addPhoneNumber", params);
      this.isLoading = false;
      this.$bvModal.show("modal-error");
    },
    async onConfirmPhoneNumber() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$error) return;
      else {
        this.isLoading = true;
        await this.$store.dispatch("auth/confirmPhoneNumber", {
          access_token: this.access_token,
          code: this.code,
        });
        this.isLoading = false;
        if (!this.errConfirmPhoneNumber) {
          await this.$store.dispatch("auth/setMFA", {
            access_token: this.access_token,
            flag: true,
            isFirstTimeRegisterPhone: true,
          });
          this.$router.push("/settings");
        }
      }
    },
    handleModal() {
      this.$bvModal.hide("modal-error");
    },
  },
  mounted() {
    if (this.phoneNumber == "") {
      this.$router.push("/settings");
    }
  },
  watch: {
    code: function () {
      this.$store.dispatch("auth/clearErrMessage");
    },
  },
};
</script>
  <style scoped>
.wrapper {
  min-height: calc(100svh - 50px);
}
</style>
